import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { DateTime } from 'luxon';

// import BlogData from "../../data/blog/blog.json";
import BlogListItems from "./Blog-Sections/BlogList-Items";
import Pagination from "../Common/Pagination";
import GoogleAdLarge from "../Ads/GoogleAdLarge";

const BlogList = ({ isPagination, blogData, blogType }) => {
  const ITEMS_PER_PAGE = 10

  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  // const selectedBlogs = blogs.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  const blogsSorted = blogs.sort((a, b) => {
    const beforeDate = DateTime.fromISO(a.date.published);
    const afterDate = DateTime.fromISO(b.date.published);
    return afterDate.toMillis() - beforeDate.toMillis()
  });
  const selectedBlogs = blogsSorted.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const latestItem = selectedBlogs.slice(0, 1)

  const handleClick = (num) => {
    setPage(num);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const getBlogs = () => {
      setBlogs(blogData.blogList);
      setTotalPages(Math.ceil(blogData.blogList.length / ITEMS_PER_PAGE));
    };

    getBlogs();
  }, [blogData, setBlogs, setTotalPages, ITEMS_PER_PAGE]);

  return (
    <>
      <>
        <div className="row">
          <div className="col-lg-10 offset-lg-1 mt_dec--30">
            {blogData &&
              selectedBlogs.slice(0, 1).map((data, index) => (
                <div className="col-12 mt--30" key={index}>
                  <div className="rbt-card variation-02 height-auto rbt-hover">
                    <div className="rbt-card-img">
                      <Link href={`/${blogType}/${data.content_id}`}>
                        <Image
                          src={data.image.poster}
                          width={1085}
                          height={645}
                          priority
                          alt="Card image"
                        />
                      </Link>
                    </div>
                    <div className="rbt-card-body">
                      <h3 className="rbt-card-title">
                        <Link href={`/${blogType}/${data.content_id}`}>
                          {data.title}
                        </Link>
                      </h3>
                      <p className="rbt-card-text">{data.desc}</p>
                      <div className="rbt-card-bottom">
                        <Link
                          className="transparent-button"
                          href={`/${blogType}/${data.content_id}`}
                        >
                          Read Article
                          <i>
                            <svg
                              width="17"
                              height="12"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                stroke="#27374D"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <path d="M10.614 0l5.629 5.629-5.63 5.629" />
                                <path
                                  strokeLinecap="square"
                                  d="M.663 5.572h14.594"
                                />
                              </g>
                            </svg>
                          </i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            <BlogListItems blogType={blogType} selectedBlogs={selectedBlogs} itemIdToAvoid={latestItem.content_id} start={0} end={ITEMS_PER_PAGE} />
          </div>
        </div>

        {isPagination ? (
          <div className="row">
            <div className="col-lg-12 mt--60">
              <Pagination
                totalPages={totalPages}
                pageNumber={page}
                handleClick={handleClick}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        <br />
        <GoogleAdLarge />
      </>
    </>
  );
};

export default BlogList;
